module.exports = __webpack_public_path__ + "static/TT-Floorplan-Floor28-a6feda8f311b5a932b1c3fced41d2843.pdf";